import { createPortal } from 'react-dom';
import { X, Lock, Sparkles } from 'lucide-react';

const FeatureRestrictionModal = ({ isOpen, onClose, onUpgrade, featureName = "This Feature" }) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-md">
      <div className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl animate-in fade-in zoom-in duration-300">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors z-10"
          aria-label="Close modal"
        >
          <X className="w-5 h-5 text-gray-500" />
        </button>

        {/* Content */}
        <div className="p-8 text-center">
          {/* Icon */}
          <div className="mx-auto w-16 h-16 bg-gradient-to-br from-amber-100 to-orange-100 rounded-full flex items-center justify-center mb-6">
            <Lock className="w-8 h-8 text-orange-600" />
          </div>

          {/* Title */}
          <h2 className="text-2xl font-bold text-gray-900 mb-3">
            {featureName} is Locked
          </h2>

          {/* Description */}
          <p className="text-gray-600 mb-2 leading-relaxed">
            This feature is not available in your current plan.
          </p>
          <p className="text-gray-600 mb-6 leading-relaxed">
            Upgrade to unlock this feature and access all premium benefits!
          </p>

          {/* Benefits List */}
          <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-4 mb-6 text-left">
            <div className="flex items-start gap-3 mb-2">
              <Sparkles className="w-5 h-5 text-orange-600 flex-shrink-0 mt-0.5" />
              <p className="text-sm text-gray-700 font-medium">
                Access all premium features
              </p>
            </div>
            <div className="flex items-start gap-3 mb-2">
              <Sparkles className="w-5 h-5 text-orange-600 flex-shrink-0 mt-0.5" />
              <p className="text-sm text-gray-700 font-medium">
                Unlimited career reports
              </p>
            </div>
            <div className="flex items-start gap-3">
              <Sparkles className="w-5 h-5 text-orange-600 flex-shrink-0 mt-0.5" />
              <p className="text-sm text-gray-700 font-medium">
                Priority support and guidance
              </p>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col gap-3">
            <button
              onClick={onUpgrade}
              className="w-full py-3 px-6 bg-gradient-to-r from-[#1a2642] to-[#2a3652] text-white rounded-lg font-semibold shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all duration-200 flex items-center justify-center gap-2"
            >
              <Sparkles className="w-5 h-5" />
              Upgrade Plan
            </button>
            <button
              onClick={onClose}
              className="w-full py-3 px-6 bg-gray-100 text-gray-700 rounded-lg font-semibold hover:bg-gray-200 transition-colors"
            >
              Maybe Later
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default FeatureRestrictionModal;
